/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Col, Container, Form, Row, Card, Button, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import SelectPhoneCodeInput from 'components/input/SelectPhoneCodeInput';
import TextIconInput from 'components/input/TextIconInput';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CheckboxInput from 'components/input/CheckboxInput';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getContactDetail, updateContact } from 'app/basicInformationSlice/basicInformationSlice';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import { BoolToString, formatBoolean } from 'components/helper/helper';
import LoadingContent from 'components/LoadingContent';
import { contactDetailRules } from './validations';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { debounce } from 'lodash';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { useLocation } from 'react-router-dom';
import Grid from '@mui/joy/Grid';
import { ModalCheckField } from 'screen/common/ModalCheckField';
import SearchIcon from '@mui/icons-material/Search';
import websocketService from 'services/websocketService';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

interface Props {}

const ContactDetailPage = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const basicInformationStore = useAppSelector((store) => store.basicInformation);
  const query = new URLSearchParams(useLocation().search);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);

  const check = query.get('check');
  const formik = useFormik({
    initialValues: {
      country_code: undefined,
      phone_number: undefined,
      phone_number_type: 'home',
      is_have_alternative_phone_number: '',
      alternative_country_code: undefined,
      alternative_phone_number: undefined,
      alternative_phone_number_type: 'home',
      is_allowed_share_contact: true,
      is_authorized_text_message_sent: false,
      is_have_international_phone_number: false,
      alternative_is_authorized_text_message_sent: true,
      is_agree_csu_term: false,
      current_enrollment_status: '',
      year_plan_college_studies: '',
      is_need_based_financial_aid: '',
      is_inconsistent_access_internet: false,
      is_lost_my_job: false,
      is_parent_lost_their_job: false,
      is_essential_worker: false,
      is_parent_essential_worker: false,
      is_in_curfew_community: false,
      is_changed_home_responsibilities: false,
      is_health_affected: false,
      is_household_helth_affected: false,
      is_none_applied: false,
      is_none_above_apply_to_me: false,
      is_have_additional_information: false,
      additional_information: '',
      alternative_is_have_international_phone_number: false,
    },
    validationSchema: contactDetailRules,
    onSubmit: async (values) => {
      let newValues:any = {
        ...values,
        is_have_alternative_phone_number: formatBoolean(values.is_have_alternative_phone_number),
        student_id: parseInt(studentId || ''),
      };

      //#region reset/clear values on save
      if (newValues.is_have_alternative_phone_number=== false) {
        newValues.alternative_phone_number = '';
        newValues.alternative_country_code = '';
        newValues.alternative_is_have_international_phone_number = false;
      }
      //#endregion

      window.Intercom('update', {
        phone: values.phone_number,
      });

      await dispatch(updateContact(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = async () => {
    await formik.handleSubmit();
    history.push(routers.demographics.path);
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Prepare data for modal check
  const getModalData = () => {
    return {
      ...formik.values,
    };
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.CONTACT_DETAILS);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let res: any = await dispatch(getContactDetail(studentId));
      const dataLoaded: any = { ...res.payload };
      const values: any = {
        ...formik.values,
        ...dataLoaded,
        is_have_international_phone_number: dataLoaded.is_have_international_phone_number,
        is_have_alternative_phone_number: BoolToString(dataLoaded.is_have_alternative_phone_number ?? 'false'),
        phone_number_type: dataLoaded.phone_number_type ?? 'home',
        alternative_phone_number_type: dataLoaded.alternative_phone_number_type ?? 'home',
        alternative_is_have_international_phone_number: dataLoaded.alternative_is_have_international_phone_number ?? false,
      };

      window.Intercom('update', {
        phone: values.phone_number,
      });

      formik.setValues(values);
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
  }, []);
  const [disabledField, setDisabledField] = React.useState(false);
  React.useEffect(() => {
    disabledField &&
      formik.setValues({
        ...formik.values,
        is_inconsistent_access_internet: false,
        is_lost_my_job: false,
        is_parent_lost_their_job: false,
        is_essential_worker: false,
        is_parent_essential_worker: false,
        is_in_curfew_community: false,
        is_changed_home_responsibilities: false,
        is_health_affected: false,
        is_household_helth_affected: false,
      });
  }, [disabledField]);
  React.useEffect(() => {
    formik.values.is_none_applied ? setDisabledField(true) : setDisabledField(false);
  }, [formik.values.is_none_applied]);

  // Auto save function ==========
  React.useEffect(() => {
    if (!!formik.status) debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // Auto save function ==========

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const onReviewdAndComplete = () => { 
    const newValue = !reviewedAndComplete;
    setReviewedAndComplete(newValue);
    websocketService.finishReviewAndComplete(PAGE_NAME.CONTACT_DETAILS, newValue);
  }

  return loading ? (
    <LoadingContent />
  ) : (
    <div>
      <TopProcessBar
        stepProcess={[
          {
            title: 'Phone Number',
            specialId: 'contact-details',
            percentOnProcess: 0,
          },
          {
            title: 'Alternative Phone Number',
            specialId: 'alternative-phone-number',
            percentOnProcess: 60,
          }
        ]}
        title="Contact Details"
        process={1}
        icon={<PersonOutlineOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="contact-details" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Contact Details
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className={`${isMobile ? 'fs-6' : 'fs-5'} p-1`}>
                  <span style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 600 }}>
                    What is your phone number?
                  </span>
                </div>
              </Grid>
              <Grid xs={12}>
                <CheckboxInput
                  name="is_have_international_phone_number"
                  values={formik.values.is_have_international_phone_number}
                  label="I have an international phone number"
                  onChange={formik.handleChange}
                  disabled={reviewedAndComplete}
                />
              </Grid>
              <Grid xs={12}>
                <div className="text-field-light" style={{ fontSize: isMobile ? '14px' : '16px' }}>
                  This address is your permanent address. It's most likely where your parents or
                  legal guardians live. If you're an international student, please enter your home
                  country address.
                </div>
              </Grid>

              {formik.values.is_have_international_phone_number && (
                <Grid xs={12} md={6}>
                  <SelectPhoneCodeInput
                    label="Country Code*"
                    name="country_code"
                    onChange={formik.handleChange}
                    values={formik.values.country_code}
                    disabled={reviewedAndComplete}
                    isMissing={!formik.values.country_code && check ? true : false}
                  />
                </Grid>
              )}
              <Grid xs={12} md={6}>
                <TextIconInput
                  icon={<PhoneAndroidIcon />}
                  name="phone_number"
                  onChange={formik.handleChange}
                  values={formik.values.phone_number}
                  label="Phone Number*"
                  hiddenFeedback={true}
                  disabled={reviewedAndComplete}
                  isMissing={!formik.values.phone_number && check ? true : false}
                />
              </Grid>
              <Grid xs={12}>
                <GroupRadioButton
                  mdCol={6}
                  name={'phone_number_type'}
                  columns={3}
                  hiddenFormLabel={true}
                  values={formik.values.phone_number_type}
                  onChange={formik.handleChange}
                  disabled={reviewedAndComplete}
                  options={[
                    { label: 'Home / Other', value: 'home' },
                    { label: 'Cell / Mobile', value: 'cell' },
                  ]}
                />
              </Grid>
              {formik.values.phone_number_type === 'cell' && (
                <Grid xs={12}>
                  <div className="my-1">
                    <CheckboxInput
                      logo="span-uc-logo"
                      setLabelHight={true}
                      mdCol={'12'}
                      label={
                        'I authorize text messages (for example, reminders about application deadlines) to be sent to the above phone number and accept responsibility for any charges incurred.'
                      }
                      name={'is_authorized_text_message_sent'}
                      values={formik.values.is_authorized_text_message_sent}
                      onChange={(e) => {
                        formik.setFieldValue('is_authorized_text_message_sent', e.target.checked);
                      }}
                      disabled={reviewedAndComplete}
                    />
                  </div>
                </Grid>
              )}
              <Grid xs={12} className={isMobile ? 'pt-2' : 'pt-3'}>
                <div className="span-csu-logo" style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: 600 }}>
                  Text and Phone Authorization
                </div>
              </Grid>
              <Grid xs={12}>
                <CheckboxInput
                  mdCol={'12'}
                  label={
                    <span className="mt-2">
                      I agree to the Terms of Service and to receive calls and/or texts at any phone
                      number I have provided or may provide in the future, including any wireless
                      number, from any entity associated with my application process, including but
                      not limited to my designated schools and programs, the Liaison International
                      support team, the association or institution for this Centralized Application
                      Service.
                    </span>
                  }
                  name={'is_agree_csu_term'}
                  values={formik.values.is_agree_csu_term}
                  onChange={(e) => {
                    formik.setFieldValue('is_agree_csu_term', e.target.checked);
                  }}
                  disabled={reviewedAndComplete}
                />
              </Grid>
              <Grid xs={12} className={isMobile ? 'pt-2' : 'pt-3'}>
                <YesNoSwitch
                  name={'is_have_alternative_phone_number'}
                  values={formik.values.is_have_alternative_phone_number}
                  onChange={formik.handleChange}
                  label="Do you have an alternative phone number in case we can't contact you?"
                  disabled={reviewedAndComplete}
                />
              </Grid>
              {formik.values.is_have_alternative_phone_number==='true' && (
                <Grid xs={12}>
                  <Card 
                    body 
                    className={`bg-white border-0 w-100 ${isMobile ? 'p-mobile-1 mt-2' : 'px-1 mt-3'}`}
                    style={{
                      borderRadius: isMobile ? '12px' : '8px',
                      boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.1)' : undefined
                    }}
                  >
                    <div id="alternative-phone-number" style={{ 
                      fontSize: isMobile ? '16px' : '18px', 
                      fontWeight: 600,
                      marginBottom: isMobile ? '8px' : '12px'
                    }}>
                      Alternative Phone Number
                    </div>
                    <Grid container spacing={isMobile ? 1 : 2} className="my-1">
                      <Grid xs={12}>
                        <CheckboxInput
                          name="alternative_is_have_international_phone_number"
                          values={formik.values.alternative_is_have_international_phone_number}
                          label="I have an international phone number"
                          onChange={formik.handleChange}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>
                      {formik.values.alternative_is_have_international_phone_number && (
                        <Grid xs={12} md={6}>
                          <SelectPhoneCodeInput
                            label="Country Code*"
                            name="alternative_country_code"
                            onChange={formik.handleChange}
                            values={formik.values.alternative_country_code}
                            disabled={reviewedAndComplete}
                          />
                        </Grid>
                      )}
                      <Grid xs={12} md={6}>
                        <TextIconInput
                          icon={<PhoneAndroidIcon />}
                          name="alternative_phone_number"
                          onChange={formik.handleChange}
                          values={formik.values.alternative_phone_number}
                          label={
                            formik.values.alternative_is_have_international_phone_number
                              ? 'Phone Number*'
                              : 'Phone Number'
                          }
                          hiddenFeedback={true}
                          disabled={reviewedAndComplete}
                          isMissing={
                            !formik.values.alternative_phone_number && check ? true : false
                          }
                        />
                      </Grid>
                      <Grid xs={12} >
                        <GroupRadioButton
                          mdCol={6}
                          columns={3}
                          name={'alternative_phone_number_type'}
                          hiddenFormLabel={true}
                          values={formik.values.alternative_phone_number_type}
                          onChange={formik.handleChange}
                          disabled={reviewedAndComplete}
                          options={[
                            { label: 'Home / Other', value: 'home' },
                            { label: 'Cell / Mobile', value: 'cell' },
                          ]}
                        />
                      </Grid>

                      {formik.values.alternative_phone_number_type === 'cell' && (
                        <Grid xs={12}>
                          <div className="my-1">
                            <CheckboxInput
                              // mdCol={'12'}
                              label={
                                <span className="mt-2 text-primary">
                                  I authorize text messages (for example, reminders about
                                  application deadlines) to be sent to the above phone number and
                                  accept responsibility for any charges incurred.
                                </span>
                              }
                              name={'alternative_is_authorized_text_message_sent'}
                              values={formik.values.alternative_is_authorized_text_message_sent}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  'alternative_is_authorized_text_message_sent',
                                  e.target.checked
                                );
                              }}
                              disabled={reviewedAndComplete}
                            />
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </Card>
                </Grid>
              )}
              <Grid xs={12} className={isMobile ? 'pt-2' : 'pt-3'}>
                <div className={`${isMobile ? 'fs-6' : 'fs-5'} p-1 my-0`}>
                  <span style={{ fontSize: isMobile ? '16px' : '18px', fontWeight: 600 }}>Can we share your contact information with UC campuses and programs?</span>
                </div>
              </Grid>
              <Grid xs={12}>
                <p className="text-field-light" style={{ fontSize: isMobile ? '14px' : '16px' }}>
                  If you check this option, you may receive information about admissions tips,
                  updates and reminders from UC campuses (even ones you haven't applied to) and
                  outreach programs. They may contact you before and/or after you've submitted the
                  application.
                </p>
              </Grid>
              <Grid xs={12}>
                <div className="my-1">
                  <CheckboxInput
                    mdCol={'6'}
                    label={
                      <span className="mt-2 text-primary">
                        I authorize the University of California to share my contact information.
                      </span>
                    }
                    name={'is_allowed_share_contact'}
                    values={formik.values.is_allowed_share_contact}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </div>
              </Grid>
            </Grid>
            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed & Complete!
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {basicInformationStore.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
      
      <ModalCheckField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page="contact-details"
      />
    </div>
  );
};

export default ContactDetailPage;
